export const OFFER_COUNT_TYPES = [
  'active',
  'scheduled',
  'paused',
  'draft',
  'expired',
  'archived',
];

const OFFER_COUNT_TYPE_SET = new Set(OFFER_COUNT_TYPES);

export const normalizeOfferCountRefreshTargets = (targets) => (
  [...new Set((Array.isArray(targets) ? targets : [])
    .map(target => String(target).toLowerCase())
    .filter(target => OFFER_COUNT_TYPE_SET.has(target)))]
);

export const fetchOfferCounts = async ({
  businessId,
  fetcher,
  targets = OFFER_COUNT_TYPES,
}) => {
  const statuses = normalizeOfferCountRefreshTargets(targets);
  const entries = await Promise.all(statuses.map(async (status) => {
    try {
      if (status === 'draft') {
        const drafts = await fetcher(`/drafts/business/${businessId}/page?size=1&page=0`);
        return [status, drafts.totalElements];
      }

      const response = await fetcher(
        `/offer/business/${businessId}?status=${status.toUpperCase()}&size=1&page=0`
      );
      return [status, response.totalElements];
    } catch {
      return null;
    }
  }));

  return Object.fromEntries(entries.filter(Boolean));
};
